import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'lib-bo-auth-brand',
  standalone: true,
  templateUrl: './bo-auth-brand.component.html',
  styleUrls: ['./bo-auth-brand.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoAuthBrandComponent {
  readonly appName = input('My Sport App');
  readonly tagline = input('Gestion de canchas');
}
